import { Stack } from 'expo-router';
import React from 'react';

import ConversationalOnboardingQARunsListPage from '../../../llm-service/conversational-mm/ConversationalOnboardingQARunsListPage';

export default function ConversationalOnboardingQAIndexPage() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Conversational Onboarding QA',
                }}
            />
            <ConversationalOnboardingQARunsListPage />
        </>
    );
}
